import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import image from "_assets/images/PRM-Logo-PNG/cropped-email.png";
import image2 from "_assets/images/PRM-Logo-PNG/prm-invite-cropped.png";

const EmailInvite = () => {
    return (
        <>
          <Container>
            <Row>
              <div>
                <img
                  src={image}
                  style={{borderRadius:30}}
                  height={200}
                />
                <img
                  src={image2}
                  style={{borderRadius:20}}
                  height={510}
                />
              </div>
            </Row>
          </Container>      
        </>
    );
};

export default EmailInvite;
